/**
 * <cm-preorder-badge>
 *
 * Listens for variant:update events on its enclosing section. When the
 * variant changes, it looks up its counterpart in the freshly-rendered
 * variant HTML supplied with the event and morphs itself to match — so the
 * "PRE-ORDER" badge appears/disappears (and the shipping message updates)
 * without any extra fetch.
 */

class CmPreorderBadge extends HTMLElement {
  constructor() {
    super();
    this._onVariantUpdate = this._onVariantUpdate.bind(this);
  }

  connectedCallback() {
    this._scope = this.closest('.shopify-section') || document;
    this._scope.addEventListener('variant:update', this._onVariantUpdate);
  }

  disconnectedCallback() {
    if (this._scope) {
      this._scope.removeEventListener('variant:update', this._onVariantUpdate);
    }
  }

  /** @param {CustomEvent} event */
  _onVariantUpdate(event) {
    const html = event.detail?.data?.html;
    if (!html) return;

    const blockId = this.dataset.blockId;
    if (!blockId) return;

    const next = html.querySelector(`cm-preorder-badge[data-block-id="${CSS.escape(blockId)}"]`);
    if (!next) {
      this._hide();
      return;
    }

    const shouldBeVisible = next.getAttribute('data-visible') === 'true';

    this.innerHTML = next.innerHTML;
    if (next.dataset.variantId) this.dataset.variantId = next.dataset.variantId;
    if (next.dataset.inventoryQuantity) this.dataset.inventoryQuantity = next.dataset.inventoryQuantity;
    if (next.dataset.inventoryPolicy) this.dataset.inventoryPolicy = next.dataset.inventoryPolicy;
    this.dataset.visible = shouldBeVisible ? 'true' : 'false';
  }

  _hide() {
    this.dataset.visible = 'false';
    this.innerHTML = '';
  }
}

if (!customElements.get('cm-preorder-badge')) {
  customElements.define('cm-preorder-badge', CmPreorderBadge);
}
